import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Globe, MessageCircle } from 'lucide-react';
import { COMPANY } from '@/config/company';
import './Footer.css';

export default function PublicFooter() {
  return (
    <footer className="footer" style={{ backgroundColor: 'var(--bg-secondary)', borderTop: '1px solid var(--border-color)', paddingTop: 'var(--spacing-4xl)', paddingBottom: 'var(--spacing-xl)' }}>
      <div className="container">
        <div className="footer-grid">
          {/* Col 1 */}
          <div>
            <Link to="/" className="footer-logo" style={{ marginBottom: 'var(--spacing-xl)' }}>
              <span style={{ fontSize: '1.5rem', fontWeight: 800, color: 'var(--accent-gold)', letterSpacing: '1px' }}>MAYİ MİMARLIK</span>
            </Link>
            <p className="text-secondary" style={{ lineHeight: 1.6, fontSize: '0.95rem' }}>
              Güneydoğu Anadolu Bölge Distribütörü.<br/>
              Banyo, Seramik ve Yapı Malzemelerinde çeyrek asırlık tecrübe ile profesyonel çözümler.
            </p>
          </div>
          
          {/* Col 2 */}
          <div>
            <h4 className="footer-heading">Hızlı Bağlantılar</h4>
            <ul className="footer-links">
              <li><Link to="/markalar">Markalarımız</Link></li>
              <li><Link to="/urunler">Tüm Ürünler</Link></li>
              <li><Link to="/referanslar">Referanslar</Link></li>
            </ul>
          </div>

          {/* Col 3 */}
          <div>
            <h4 className="footer-heading">Kurumsal</h4>
            <ul className="footer-links">
              <li><Link to="/hakkimizda">Hakkımızda</Link></li>
              <li><Link to="/iletisim">Bize Ulaşın</Link></li>
              <li><Link to="/privacy">KVKK ve Çerez Politikası</Link></li>
              <li><Link to="/terms">Kullanım Koşulları</Link></li>
            </ul>
          </div>
          
          {/* Col 4 */}
          <div>
            <h4 className="footer-heading">İletişim Bilgileri</h4>
            <ul className="footer-contact" style={{ display: 'flex', flexDirection: 'column', gap: '1rem', listStyle: 'none', padding: 0 }}>
              <li style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start' }}>
                <MapPin size={18} color="var(--accent-gold)" style={{ marginTop: '2px' }} />
                <span className="text-secondary text-sm" style={{ lineHeight: 1.5 }}>
                  {COMPANY.address}
                </span>
              </li>
              <li style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                <Phone size={18} color="var(--accent-gold)" />
                <a href={`tel:${COMPANY.phoneTel}`} className="text-secondary text-sm transition-colors hover:text-accent">{COMPANY.phoneDisplay}</a>
              </li>
              <li style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                <MessageCircle size={18} color="var(--accent-gold)" />
                <a href={COMPANY.whatsappUrl} target="_blank" rel="noopener noreferrer" className="text-secondary text-sm transition-colors hover:text-accent">WhatsApp: {COMPANY.phoneDisplay}</a>
              </li>
              <li style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                <Mail size={18} color="var(--accent-gold)" />
                <a href={`mailto:${COMPANY.email}`} className="text-secondary text-sm transition-colors hover:text-accent">{COMPANY.email}</a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom" style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', alignItems: 'center', justifyContent: 'space-between', marginTop: 'var(--spacing-xl)', paddingTop: 'var(--spacing-xl)', borderTop: '1px solid var(--border-color)' }}>
          <p className="text-muted text-sm">© {new Date().getFullYear()} Mayi Mimarlık. Tüm Hakları Saklıdır.</p>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <a href="#" className="social-link" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '36px', height: '36px', borderRadius: '50%', backgroundColor: 'rgba(0,0,0,0.05)', color: 'var(--text-primary)', transition: 'all 0.2s' }}><Globe size={16} /></a>
          </div>
        </div>
      </div>
    </footer>
  );
}
